/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowBakingCompetitionTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowBakingCompetition,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Who’s the Best Baker?",
    "Bake Off Challenge!",
    "Let’s Get Baking!",
  ],
  title: "Baking Competition",
  description: "Organize a fun baking competition.",
  longDescription:
    "Gather your friends for an exciting baking competition! Choose a date, decide on the baked goods to prepare, and plan the judging criteria!",
  emoji: "🍰",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Party,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Baking Competition",
          emoji: "🍰",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we have the baking competition?",
          emoji: "📅",
          completeAction: {
            question: "Decide on baked goods to prepare?",
            description:
              "What baked goods should we include in the competition?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What baked goods should we bake?",
                emoji: "🧁",
                completeAction: {
                  question: "Decide on judging criteria?",
                  description:
                    "What criteria should we use to judge the baked goods?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What criteria should we use?",
                      emoji: "🏆",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "May the Best Baker Win!",
    outroDescription:
      "Your baking competition plans are set! Enjoy the sweet treats!",
  },
};
